module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Joyce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Joyce (1882–1941) was an Irish poet, novelist, and short story author and one of the most innovative artists of the twentieth century. His best-known works include "), _c('I', [_vm._v("Dubliners")]), _vm._v(","), _c('I', [_vm._v(" A Portrait of the Artist")]), _c('I', [_vm._v("as a Young Man")]), _vm._v(","), _c('I', [_vm._v(" Finnegans Wake")]), _vm._v(", and "), _c('I', [_vm._v("Ulysses")]), _vm._v(", which is widely considered to be the greatest novel in the English language. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fy2Kyk/tc-custom/9781504075633.jpg?1696633112351",
      "alt": "This image is the cover for the book Ulysses"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ulysses\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This iconic work of experimental modernism “comes nearer to being the perfect revelation of a personality than any book in existence” ("), _c('i', [_vm._v("The New York Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Taking place on June 16, 1904, "), _c('i', [_vm._v("Ulysses")]), _vm._v(" follows the itinerant journeys of Leopold Bloom and Stephen Dedalus as they make their way through an ordinary day in Dublin. With stream-of-conscious narration, Joyce weaves a sprawling yet incisive portrait of his characters, the nature of desire, and Dublin itself."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" First published in Paris in 1922, Joyce’s masterwork was once banned for obscenity in the United States and Britain. Hailed as a work of genius by Ezra Pound, Ernest Hemingway, and many others, "), _c('i', [_vm._v("Ulysses")]), _vm._v(" remains one of the most significant works in English literature.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0